import { render, staticRenderFns } from "./subAirwallexPayment.vue?vue&type=template&id=f0fb33aa&scoped=true"
import script from "./subAirwallexPayment.vue?vue&type=script&lang=js"
export * from "./subAirwallexPayment.vue?vue&type=script&lang=js"
import style0 from "./subAirwallexPayment.vue?vue&type=style&index=0&id=f0fb33aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fb33aa",
  null
  
)

export default component.exports